import api from 'Application/api/api';

const getEmployee = (id, load, cancelToken = null) =>
    api.get(`/employees/${id}`, {
        params: {
            load,
        },
        cancelToken,
    });

export default getEmployee;
